import React from "react";
import Condition from "../../components/condition/condition";
import Location from "../../components/location/location";
import Cost from "../../components/cost/cost";
import ServiceTypeBox from "../serviceType/serviceTypeBox";
import { useBreakpoint } from "@tal-gel/components-v2";
import { RowFlexBox, ColumnFlexBox } from "../common/FlexBoxes";
import styled from "@emotion/styled";

// Styled Heading6
const StyledHeading6 = styled.div<{ marginTop?: string }>`
  margin-bottom: 16px;
  margin-top: ${({ marginTop }) => marginTop || "0"};
`;

const FilterColumn = styled(ColumnFlexBox)<{ ismd: boolean }>`
  ${({ ismd }) =>
    ismd
      ? `
    width: 30%;
    max-width: 30%;
  `
      : `
    max-width: 400px;
    width: auto;
  `}
`;

const PaddedColumnFlexBox = styled(ColumnFlexBox)<{ padded?: boolean }>`
  ${({ padded }) =>
    padded
      ? `
    padding-left: 32px;
    padding-right: 32px;
  `
      : ""}
`;

const FilterRowFlexBox = styled(RowFlexBox)<{ ismd: boolean }>`
  gap: 16px;
  justify-content: space-between;
  flex-direction: ${({ ismd }) => (ismd ? "row" : "column")};
  max-width: 1080px;
`;

const Filter = (): React.ReactElement => {
  const isMD = useBreakpoint("md");

  return (
    <RowFlexBox>
      <PaddedColumnFlexBox padded={isMD}>
        <ColumnFlexBox>
          <StyledHeading6>Service Type</StyledHeading6>
          <ServiceTypeBox />
        </ColumnFlexBox>
        <FilterRowFlexBox ismd={isMD}>
          <FilterColumn ismd={isMD}>
            <StyledHeading6 marginTop="24px">Location</StyledHeading6>
            <Location />
          </FilterColumn>
          <FilterColumn ismd={isMD}>
            <StyledHeading6 marginTop="24px">Condition</StyledHeading6>
            <Condition />
          </FilterColumn>
          <FilterColumn ismd={isMD}>
            <StyledHeading6 marginTop="24px">Cost</StyledHeading6>
            <Cost />
          </FilterColumn>
        </FilterRowFlexBox>
      </PaddedColumnFlexBox>
    </RowFlexBox>
  );
};

export default Filter;
